//店铺接口
import axios from "../common.js";
import store from "../../store/index";
import { testR } from "../common";



/**
 *  服务商配置微信店铺ID
 * @param {*} mch_no
 * @returns
 */
 export const serviceSetMerchantId = function({wx_mch_no,remark}) {
  var data = {
    service_no: localStorage.getItem("service_no"),
    wx_mch_no,
    remark
  };
  axios.defaults.headers = {
    Authorization: `Token token_type=${localStorage.getItem(
      "token_type"
    )}&access_token=${localStorage.getItem("access_token")}`
  };
  return axios
    .post("ServiceProvider/v2/Pay/configure/configure", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/**
 *  获取服务商微信店铺ID
 * /ServiceProvider/v2/Pay/configure/configure
 * @returns
 */


/**
 * /merchant/v2/offlinestores/upgrade
 * 服务商远程升级用户系统
 * @param {string[]} list
 */
 export const serviceOfflinestoresUpgrade = function(list) {
  axios.defaults.headers = {
    Authorization: `Token token_type=${localStorage.getItem(
      "token_type"
    )}&access_token=${localStorage.getItem("access_token")}`
  };
  return axios
    .post("merchant/v2/offlinestores/upgrade", JSON.stringify(list))
    .catch(e => {
      Message.error(e);
    });
};